export const supportedRegionsByAlpha2RegionCode = {
  GB: {
    alpha2: 'GB',
    alpha3: 'GBR',
    defaultLanguageCode: 'en',
    shortName: 'UK',
    name: 'United Kingdom',
    flag: '🇬🇧',
  },
  US: {
    alpha2: 'US',
    alpha3: 'USA',
    defaultLanguageCode: 'en',
    shortName: 'USA',
    name: 'United States',
    flag: '🇺🇸',
  },
  IE: {
    alpha2: 'IE',
    alpha3: 'IRL',
    defaultLanguageCode: 'en',
    shortName: 'IRE',
    name: 'Ireland',
    flag: '🇮🇪',
  },
  ES: {
    alpha2: 'ES',
    alpha3: 'ESP',
    defaultLanguageCode: 'es',
    shortName: 'ESP',
    name: 'Spain',
    flag: '🇪🇸',
  },
} as const

export const imminentRegionsByAlpha2RegionCode = {
  BE: {
    alpha2: 'BE',
    alpha3: 'BEL',
    defaultLanguageCode: 'nl',
    shortName: 'BEL',
    name: 'Belgium',
    flag: '🇧🇪',
  },
  BG: {
    alpha2: 'BG',
    alpha3: 'BGR',
    defaultLanguageCode: 'bg',
    shortName: 'BGR',
    name: 'Bulgaria',
    flag: '🇧🇬',
  },
  CY: {
    alpha2: 'CY',
    alpha3: 'CYP',
    defaultLanguageCode: 'el',
    shortName: 'CYP',
    name: 'Cyprus',
    flag: '🇨🇾',
  },
  CZ: {
    alpha2: 'CZ',
    alpha3: 'CZE',
    defaultLanguageCode: 'cs',
    shortName: 'CZE',
    name: 'Czechia',
    flag: '🇨🇿',
  },
  DK: {
    alpha2: 'DK',
    alpha3: 'DNK',
    defaultLanguageCode: 'da',
    shortName: 'DNK',
    name: 'Denmark',
    flag: '🇩🇰',
  },
  EE: {
    alpha2: 'EE',
    alpha3: 'EST',
    defaultLanguageCode: 'et',
    shortName: 'EST',
    name: 'Estonia',
    flag: '🇪🇪',
  },
  FI: {
    alpha2: 'FI',
    alpha3: 'FIN',
    defaultLanguageCode: 'fi',
    shortName: 'FIN',
    name: 'Finland',
    flag: '🇫🇮',
  },
  FR: {
    alpha2: 'FR',
    alpha3: 'FRA',
    defaultLanguageCode: 'fr',
    shortName: 'FRA',
    name: 'France',
    flag: '🇫🇷',
  },
  HR: {
    alpha2: 'HR',
    alpha3: 'HRV',
    defaultLanguageCode: 'hr',
    shortName: 'HRV',
    name: 'Croatia',
    flag: '🇭🇷',
  },
  HU: {
    alpha2: 'HU',
    alpha3: 'HUN',
    defaultLanguageCode: 'hu',
    shortName: 'HUN',
    name: 'Hungary',
    flag: '🇭🇺',
  },
  IS: {
    alpha2: 'IS',
    alpha3: 'ISL',
    defaultLanguageCode: 'is',
    shortName: 'ISL',
    name: 'Iceland',
    flag: '🇮🇸',
  },
  IT: {
    alpha2: 'IT',
    alpha3: 'ITA',
    defaultLanguageCode: 'it',
    shortName: 'ITA',
    name: 'Italy',
    flag: '🇮🇹',
  },
  LI: {
    alpha2: 'LI',
    alpha3: 'LIE',
    defaultLanguageCode: 'de',
    shortName: 'LIE',
    name: 'Liechtenstein',
    flag: '🇱🇮',
  },
  LT: {
    alpha2: 'LT',
    alpha3: 'LTU',
    defaultLanguageCode: 'lt',
    shortName: 'LTU',
    name: 'Lithuania',
    flag: '🇱🇹',
  },
  LV: {
    alpha2: 'LV',
    alpha3: 'LVA',
    defaultLanguageCode: 'lv',
    shortName: 'LVA',
    name: 'Latvia',
    flag: '🇱🇻',
  },
  MT: {
    alpha2: 'MT',
    alpha3: 'MLT',
    defaultLanguageCode: 'mt',
    shortName: 'MLT',
    name: 'Malta',
    flag: '🇲🇹',
  },
  NL: {
    alpha2: 'NL',
    alpha3: 'NLD',
    defaultLanguageCode: 'nl',
    shortName: 'NLD',
    name: 'Netherlands',
    flag: '🇳🇱',
  },
  PL: {
    alpha2: 'PL',
    alpha3: 'POL',
    defaultLanguageCode: 'pl',
    shortName: 'POL',
    name: 'Poland',
    flag: '🇵🇱',
  },
  PT: {
    alpha2: 'PT',
    alpha3: 'PRT',
    defaultLanguageCode: 'pt',
    shortName: 'PRT',
    name: 'Portugal',
    flag: '🇵🇹',
  },
  RO: {
    alpha2: 'RO',
    alpha3: 'ROU',
    defaultLanguageCode: 'ro',
    shortName: 'ROU',
    name: 'Romania',
    flag: '🇷🇴',
  },
  SE: {
    alpha2: 'SE',
    alpha3: 'SWE',
    defaultLanguageCode: 'sv',
    shortName: 'SWE',
    name: 'Sweden',
    flag: '🇸🇪',
  },
  SI: {
    alpha2: 'SI',
    alpha3: 'SVN',
    defaultLanguageCode: 'sl',
    shortName: 'SVN',
    name: 'Slovenia',
    flag: '🇸🇮',
  },
  SK: {
    alpha2: 'SK',
    alpha3: 'SVK',
    defaultLanguageCode: 'sk',
    shortName: 'SVK',
    name: 'Slovakia',
    flag: '🇸🇰',
  },
} as const
